import { MesaCardSkeleton } from './MesaCardSkeleton'
import { CurrentBalanceCard } from './CurrentBalanceCard'
import { useLegacyCard } from '@/src/common/hooks/useCardInformation'
import { DesignSystem } from '@/src/design-system'

export function CurrentBalanceHighnote() {
  const cardInformationQuery = useLegacyCard()
  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await cardInformationQuery.refetch()
  })

  if (!cardInformationQuery.data?.getCreditCardInformation.node) {
    return <MesaCardSkeleton />
  }

  return (
    <CurrentBalanceCard
      cardName="Mesa Homeowners Card"
      currentBalanceInCents={
        cardInformationQuery.data.getCreditCardInformation.node.financialAccount
          .outstandingBalancePayable
      }
    />
  )
}
